var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',[_c('v-container',{staticClass:"py-0 px-8 login"},[_c('v-row',[_c('v-col',{staticClass:"page-padding mb-8 d-flex justify-center align-center",attrs:{"cols":"12"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }